import { closedPercents, type ProjectTimeline } from "../diagnosticData";

//: Uma cor por fase, na ordem em que o projeto as vive. Mesma paleta dos
//: outros empilhados do Diagnóstico.
export const PHASE_BAR: Record<string, string> = {
  explore_hh: "bg-[#4a7fd4]",
  config_hh: "bg-[#08254c]",
  test_hh: "bg-[#c8a94b]",
  deploy_hh: "bg-[#27a155]",
  hypercare_hh: "bg-[#8a94a6]",
  // O que não é fase: OCM, PMO, adders e contingência. Cinza porque não é uma
  // etapa do projeto, mas está na barra porque está no total que produz os
  // meses do card.
  overhead_hh: "bg-[#d5dbe4]",
};

/** A mensagem de cada motivo, um caso por valor e nenhum fallback.
 *
 * Fallback foi o que a própria PR condenou: com ele, um motivo novo passa a
 * imprimir a frase de outro, que é o defeito de diagnóstico errado que já
 * apareceu duas vezes aqui. `duration` devolve nada porque a mensagem dela já
 * saiu ao lado do número.
 */
export function missingMessage(
  missing: ProjectTimeline["missing"],
  t: (key: string) => string,
): string | null {
  switch (missing) {
    case "duration":
      return null;
    case "total":
      return t(
        "This published version does not carry the project total — without it the phases cannot be put in proportion.",
      );
    case "inconsistent":
      return t(
        "The five phases do not add up to the subtotal this run used — the breakdown is not shown so it does not mislead.",
      );
    case "phases":
      return t(
        "This published version does not carry the effort by phase — calibrate again to see the breakdown.",
      );
    case null:
      //: Inalcançável: `phases` só é nulo com um motivo declarado. Fica como
      //: caso, e não como `default`, para um motivo novo quebrar o `tsc` em
      //: vez de herdar a frase de outro.
      return null;
  }
}

/**
 * O esforço de cada fase em %, na ordem de `phases`, fechado em 100. O Ato 4 e o
 * Resumo desenham a mesma partição, e por isso o arredondamento mora aqui.
 */
export function phasePercents(phases: NonNullable<ProjectTimeline["phases"]>): number[] {
  const total = phases.reduce((sum, phase) => sum + phase.hours, 0);
  return total > 0 ? closedPercents(phases.map((phase) => phase.hours), total) : phases.map(() => 0);
}
